import React from "react";
import Home from "../../Home/home";

const Ecommerse = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default Ecommerse;
